export const joinPodUrl = (podUrl: string, path: string): string => {
  const base = podUrl.replace(/\/+$/, '');
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${base}${suffix}`;
};
